import React from "react";
import type { IBadgeCategories } from "types/insights/product-badges";
import { format } from "lib/globalize-util";
import Badge from "./badge";
import { DATATEST } from "constants/integration";

interface ITopColorBadge {
    productBadges: IBadgeCategories;
}

const TopColorBadge: React.FC<ITopColorBadge> = ({ productBadges }) => {
    const name = format("Top color");
    const tooltipTitle = format("Order Trends");
    const tooltipTextList = [format(`#${productBadges.color.rank} Color in USD orders within the last 12 months`)];

    return (
        <Badge
            name={name}
            tooltipTitle={tooltipTitle}
            tooltipTextList={tooltipTextList}
            marginBottom={false}
            dataTest={DATATEST.INSIGHTS.COLOR.BADGE}
        />
    );
};

export default TopColorBadge;
